/* Core & libraries */
import React, {useEffect} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useTravelerServiceWithLocationData } from "../../services/travelerService";
import { useParams } from "react-router";
import { useAnalytics } from "../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../constants/appConstants";

/* Components */
import TravelerDetailsHeader from "../../components/travelerDetailsHeader";
import TravelerDetailsTabbedNav from "../../components/travelerDetailsTabbedNav";

/* Styles */
import styles from "./styles.js"


const TravelerDetails = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["travelerDetails"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  let { travelerId } = useParams();
  const { travelerDetails, refetchTravelerDetails } = useTravelerServiceWithLocationData(travelerId);

  return (
    <div className={classes.teamDetails}>
      <TravelerDetailsHeader travelerDetails={travelerDetails}/>
      <TravelerDetailsTabbedNav travelerDetails={travelerDetails} refetchTravelerDetails={refetchTravelerDetails}/>
    </div>
  )
}

export default TravelerDetails;
